<template>
	<div class='mzl'>
		<div v-for="item in valuesProfList" class='mzl-grid-container' :key="item.id">
			<div class="mzl-grid-container-item">
				<span>{{item.area}}</span>
			</div>
			<div class="mzl-grid-container-item">
				<span>{{item.section}}</span>
			</div>
			<div class="mzl-grid-container-item">
				<span>{{item.section_lp}}</span>
			</div>
			<div class="mzl-grid-container-item">
                <span class='select-title'>Мероприятие</span>
				<custom-p-select
					v-model='item.mzl'
					:options='mzlForRemote'
					:disabled='!actLpoIsDraft'
				/>
			</div>

			<div class="mzl-grid-container-item">
				<span class='select-title'>Рекомендуемый срок проведения мероприятий</span>
				<input type='date' class='custom-input' v-model='item.mzl_period_to' :disabled='!actLpoIsDraft'>
			</div>
			<div class="mzl-grid-container-item">
				<span class='select-title'>Профилактические мероприятия</span>
				<custom-p-select
					v-model="item.mzl_prof_ids"
					:options='info_mzl_prof'
					multiple
					:disabled='!actLpoIsDraft'
				/>
			</div>
		</div>
        <!-- <input class="add-block-btn-row" @click="saveMzl(valuesProfList)" type="button" value="Сохранить" :disabled="!needToSaveChanges(valuesProfList, valuesProfListDB)"/> -->
		<div class='values-btn-row not-match-block' v-if='needToSaveChanges(valuesProfList, valuesProfListDB)'>
			<div>
				<button @click='cancel'>Отмена</button>
				<button @click='saveMzl(valuesProfList)'>Сохранить</button>
			</div>
		</div>

	</div>
</template>

<script>
    import requestToApi from "@/lib/requestToApi";
	import { mapState, mapActions } from 'vuex';
    const ROOT_API = process.env.VUE_APP_ROOT_API;
    const INSPECTION_MZL = ROOT_API + 'get_site_data/mzl.php';
	export default {
		name: 'InspectionMzl',
		components: {
		},
		data() {
			return {
                mzlForRemote: [
                    {id: "-3", name: "не назначаются"},
                    {id: "370", name: "Проведение ЛПО инструментальным способом"},
                    {id: "371", name: "Проведение ЛПО визуальным способом наземным методом"},
                ],
				valueProfList: [],
                valuesProfList: [],
                valuesProfListDB: [],
                profMzlList: [],

				valueInstrumRecommended: false,

				values: {

					mzl_period_to: {
						field: 'mzl_period_to',
						inputType: 'date',
						value: null
					},

				},

				catalogsAreLoading: false
			};
		},
		computed: {
			lpoList() {
				return this.actLpoList.map(e => {
					return {"area": e.area, "section": e.section, "section_lp": e.section_lp, "id": e.lpo_id}
				}) 
			},
			actLpoIsDraft() { return this.$store.getters['lpoData/actLpoIsDraft']; },

			instrumRecommended() {
				return !!this.valueInstrumRecommended;
			},

			notMatchingValues() {
				const result = [];

				for (const value_name in this.values) {
					if (!this.isMatch(this.values[value_name])) {
						result.push(value_name);
					}
				}

				return result;
			},

			notMatchingProfList() {

				const finded = this.profMzlList.find(mzl => mzl.mzl_id === '370');

				let profMzlListLength = this.profMzlList.length;

				if (finded) {
					profMzlListLength--;
				}

				if (this.valueProfList.length !== profMzlListLength) {
					return true;
				}

				for (const mzl of this.profMzlList) {
					if (mzl.mzl_id === '370') {
						continue;
					}

					if (!this.valueProfList.find(m => m.id === mzl.mzl_id)) {
						return true;
					}
				}

				return false;
			},
			...mapState("lpoData", {
				actLpoList: (state) => state.actLpoList,
			}),
			...mapState('selectedLpo', {
				lpo: state => state['lpo'],
				
				//profMzlList: state => state['profMzlList'],
			}),

			...mapState({
				info_mzl_prof: state => state.catalogs['info_mzl_prof'],
			})
		},
		watch: {
			profMzlList() {
				this.resetProfList();
			}
		},
		methods: {
            needToSaveChanges(current, db) {
                for (let i = 0; i < current.length; i++) {
                    if (!this.objectsIsDeepEqual(current[i], db[i])) {
                        return true;
                    }
                }
                return false;
            },
            objectsIsDeepEqual(object1, object2) {
                const objKeys1 = Object.keys(object1);
                const objKeys2 = Object.keys(object2);
            
                if (objKeys1.length !== objKeys2.length) return false;
            
                for (var key of objKeys1) {
                    const value1 = object1[key];
                    const value2 = object2[key];
            
                    const isObjects = this.isObject(value1) && this.isObject(value2);
            
                    if ((isObjects && !this.objectsIsDeepEqual(value1, value2)) ||
                    (!isObjects && value1 !== value2)
                    ) {
                        return false;
                    }
                }
                return true;   
            },
            isObject(object) {
                return object != null && typeof object === "object";
            },
            async saveMzl(valuesProfList) {
                let params = {
                    type: "post",
                    url: INSPECTION_MZL,
                    params: {lpo_id: this.lpo.lpo_id, mzl: JSON.stringify(valuesProfList)}
                }
                const result = await requestToApi(params);
                if (result.code == 0) {
                    this.getInspectionMzl();
                } else {
                    alert("ошибка сохранения: " + result.name)
                }
            },
            async getInspectionMzl() {
                let params = {
                    url: INSPECTION_MZL,
                    params: {lpo_id: this.lpo.lpo_id}
                }
                const data = await requestToApi(params);
                this.valuesProfListDB = JSON.parse(JSON.stringify(data));
                this.valuesProfList = data;
            },
            notMatchingProfList1(selectedProfs) {
                const finded = this.profMzlList.find(mzl => mzl.mzl_id === '370');
                let profMzlListLength = this.profMzlList.length;
                if (finded) {
                    profMzlListLength--;
                }
                if (this.valueProfList.length !== profMzlListLength) {
                    return true;
                }
                for (const mzl of this.profMzlList) {
                    if (mzl.mzl_id === '370') {
                        continue;
                    }

                    if (!this.valueProfList.find(m => m.id === mzl.mzl_id)) {
                        return true;
                    }
                }
                return false;
            },
            onSelectProfList(event, lpo_id) {
                this.valuesProfList[lpo_id] = event;
                this.valuesProfList = {...this.valuesProfList};
            },
            selectedProfList(lpo_id) {
                if(!this.valuesProfList.hasOwnProperty(lpo_id)) {
                     return [];
                }
                return this.valuesProfList[lpo_id];
            },

			onInstrumRecommendedChange(checked) {
				this.toggleInstrumRecommended({ checked, mzlValue: this.valueInstrumRecommended }).then(res => {
					return this.updateProfMzlList();
				});
			},

			save() {

				if (this.notMatchingProfList) {
					this.saveProfMzlList(this.valueProfList).then(res => {
						this.updateProfMzlList();
					});
				}

				// if (this.notMatchingValues.length) {

				// 	const valueList = [];

				// 	for (const value_name of this.notMatchingValues) {
				// 		const inputTypeIsSelect = this.values[value_name].inputType === 'select';
				// 		const inputTypeIsDate = this.values[value_name].inputType === 'date';
				// 		if (inputTypeIsDate) {
				// 			if (this.values[value_name].value == '') {
				// 				this.values[value_name].value = null
				// 			}
				// 		}
				// 		const temp = {
				// 			field: this.values[value_name].field,
				// 			value: inputTypeIsSelect && this.values[value_name].value ? this.values[value_name].value.id : this.values[value_name].value,
				// 		};
				// 		valueList.push(temp);
				// 	}
					
				// 	this.saveLpoValue(valueList).then(res => {
				// 		return this.updateLpo();
				// 	});
				// }

			},
			cancel() {
				this.valuesProfList = JSON.parse(JSON.stringify(this.valuesProfListDB));
			},

			resetValues() {
				for (let value_name in this.values) {
					const value = this.values[value_name];

					if (value.inputType === 'checkbox') {
						value.value = this.lpo[value.field] === 't';
					} else if (value.inputType === 'select') {

						const temp = this[value.catalog].find(item => {
							return item.id === this.lpo[value.field];
						});
						value.value = temp ? temp : null;

					} else if (value.inputType === 'input' || value.inputType === 'date') {
						value.value = this.lpo[value.field];
					}
				}

				this.resetProfList();
			},


			resetProfList() {
				this.valueProfList = [];
				this.valueInstrumRecommended = null;

				for (const mzl of this.profMzlList) {
					if (mzl.mzl_id === '370') {
						this.valueInstrumRecommended = mzl;
						continue;
					}

					const temp = {
						id: mzl.mzl_id,
						name: mzl.name
					};

					this.valueProfList.push(temp);

				}

				// 	const temp = {
				// 		id: mzl.mzl_id,
				// 		name: mzl.name
				// 	};

				// 	this.valueProfList.push(temp);
				// }
			},

			isMatch(value) {
				if (this.catalogsAreLoading) {
					return true;
				}

				if (value.inputType === 'input' || value.inputType === 'date') {
					return value.value === this.lpo[value.field];
				} else if (value.inputType === 'select') {
					if (!value.value) {
						return this.lpo[value.field] === null;
					} else {
						return value.value.id === this.lpo[value.field];
					}
				} else if (value.inputType === 'checkbox') {
					return value.value === (this.lpo[value.field] === 't' ? true : false);
				}

				return false;
			},

			...mapActions('selectedLpo', [
				'saveProfMzlList',
				'updateProfMzlList',
				'saveLpoValue',
				'updateLpo',
				'toggleInstrumRecommended'
			])
		},
		created() {
            this.getInspectionMzl();
			const catalogs = [
				'info_mzl_prof'
			];

			this.catalogsAreLoading = true;
			this.$store.dispatch('loadCatalogs', catalogs).then(res => {
				this.catalogsAreLoading = false;
				this.resetValues();
			});
		}
	};
</script>

<style scoped src='@/style/grid.css'></style>
<style scoped src='@/style/input.css'></style>
<style scoped src='@/style/button.css'></style>

<style scoped>
	.grid.col-2 {
		grid-template-columns: repeat(auto-fill, minmax(500px, 1fr));
		padding: 0;
	}

	.grid {
		align-items: center;
	}

	.flex {
		display: flex;
	}
	.flex-item {
		flex: 1;
	}


	.agit-prof-block {
		margin-top: 10px;
	}

	.not-match {
		background-color: orange;
	}

	.select-value-block {
		margin-top: 34px;
	}

	.select-title {
		font-weight: bold;
		display: inline-block;
		margin-bottom: 6px;
	}

	.mzl-grid-container {
		display: grid;
        grid-template-columns: 1fr 1fr 2fr 7fr 5fr 8fr; /* Задаем различные доли для каждой колонки */
        gap: 4px; /* Промежутки между блоками */
		margin-bottom: 6px;
	}
	.mzl-grid-container-item {
		border: 1px solid rgb(190, 188, 188);
		/*background-color: #4CAF50;*/ /* Цвет фона */
        /*color: white; *//* Цвет текста */
        padding: 6px; /* Отступы внутри блоков */
        text-align: center; /* Выравнивание текста по центру */
	}
</style>